import { lazy, Suspense, useState } from "react";
import { ShoppingBag } from "lucide-react";
import { useCartStore } from "@/stores/cartStore";
import { useT } from "@/i18n";

// Load the full cart sheet (radix dialog + sonner toast + checkout logic)
// only when the user opens the cart. Keeps ~15-20 kB gzip out of the
// initial main bundle.
const CartSheet = lazy(() => import("./CartSheet"));

export function CartButton() {
  const items = useCartStore((s) => s.items);
  const totalItems = items.reduce((s, i) => s + i.quantity, 0);
  const t = useT();
  const [mounted, setMounted] = useState(false);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setMounted(true);
    setOpen(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleOpen}
        className="relative text-sm text-muted-foreground transition-colors hover:text-foreground"
        aria-label={totalItems > 0 ? `${t("cart.aria")} (${totalItems})` : t("cart.aria")}
      >
        <ShoppingBag className="h-5 w-5" />
        {totalItems > 0 && (
          <span
            aria-hidden
            className="absolute -top-1.5 -right-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-foreground px-1 text-[9px] font-medium tabular-nums text-background"
          >
            {totalItems}
          </span>
        )}
      </button>
      {mounted && (
        <Suspense fallback={null}>
          <CartSheet open={open} onOpenChange={setOpen} />
        </Suspense>
      )}
    </>
  );
}